import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
import { HelmetProvider } from 'react-helmet-async';
// Set page title
document.title = 'Fifth Door';
render(<HelmetProvider data-id="element-129">
    <AppRouter data-id="element-130" />
  </HelmetProvider>, document.getElementById('root'));